import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["selectAll", "include", "row", "count", "totalIn", "totalOut"];

  connect() {
    this.recount();
  }

  toggleAll() {
    const checked = this.selectAllTarget.checked;
    this.includeTargets.forEach((box) => {
      box.checked = checked;
    });
    this.recount();
  }

  recount() {
    let count = 0;
    let totalIn = 0;
    let totalOut = 0;

    this.rowTargets.forEach((row) => {
      const include = row.querySelector("[data-statement-import-target='include']");
      if (!include || !include.checked) return;

      count += 1;
      const amountField = row.querySelector("input[type='number']");
      const amount = parseFloat(amountField ? amountField.value : row.dataset.amount) || 0;
      if (row.dataset.direction === "credit") {
        totalIn += amount;
      } else {
        totalOut += amount;
      }
    });

    if (this.hasCountTarget) this.countTarget.textContent = count;
    if (this.hasTotalInTarget) this.totalInTarget.textContent = this.format(totalIn);
    if (this.hasTotalOutTarget) this.totalOutTarget.textContent = this.format(totalOut);
    this.syncSelectAll();
  }

  syncSelectAll() {
    if (!this.hasSelectAllTarget) return;
    const total = this.includeTargets.length;
    const selected = this.includeTargets.filter((box) => box.checked).length;
    this.selectAllTarget.checked = selected === total && total > 0;
    this.selectAllTarget.indeterminate = selected > 0 && selected < total;
  }

  format(value) {
    return `$${value.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
  }
}
